import { render, staticRenderFns } from "./MeasurementSpecificationsTemplateBadges.vue?vue&type=template&id=7b05bd92"
import script from "./MeasurementSpecificationsTemplateBadges.vue?vue&type=script&lang=ts"
export * from "./MeasurementSpecificationsTemplateBadges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports